import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { Modal } from "react-bootstrap";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import { fetchAllCategory } from "helpers/category_helper";
import { deleteSubCategory, fetchAllSubCategory, updateSubCategory } from "helpers/subCategory_helper";
import Select from "react-select"
import { fetchAllTrainers } from "helpers/user_helper";
import { select } from "redux-saga/effects";
import { getReferralByUser } from "helpers/refer_helper";
const AllReferrals = (props) => {
    document.title = "Refer & Earn | All Referrals";
    const [modalShow, setModalShow] = useState(false);
    const [category, setCategory] = useState(null);
    const [trainer, setTrainer] = useState(null);
    const [subCategoryName, setSubCategoryName] = useState("");
    const [subCategoryDescription, setSubCategoryDescription] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [id, setId] = useState({});
    const [loader, setLoader] = useState(false);
    const [allSubCategory, setAllSubCategory] = useState([]);
    const [page, setPage] = useState(1);
    const [categories, setCategories] = useState([]);
    const [allTrainers, setAllTrainers] = useState([]);
    const [referralStatus, setReferralStatus] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [referralHistory, setReferralHistory] = useState([]);
    const breadcrumbItems = [
        { title: "Referrals", link: "#" },
        { title: "All Referrals", link: "#" },
    ]

    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    useEffect(() => {
        props.setBreadcrumbItems('All Referrals', breadcrumbItems);
    })

    const referralStatusData = [
        { id: 1, name: "Success" },
        { id: 2, name: "Pending" },
        { id: 3, name: "All" },
    ]

    const fetchTrainers = async () => {
        try {
            const data = await fetchAllTrainers();
            setAllTrainers(data?.result);
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    }


    const fetchCategories = async () => {
        try {
            const data = await fetchAllCategory();

            if (data?.success) {
                setCategories(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }


    const fetchSubCategories = async () => {
        try {
            const data = await fetchAllSubCategory();

            if (data?.success) {
                setAllSubCategory(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchSubCategories();
        fetchCategories();
        fetchTrainers();
    }, []);

    const data = {
        columns: [
            {
                label: "Serial No.",
                field: "serialNo",
                sort: "asc",
                width: 50,
            },
            {
                label: "Student Email",
                field: "studentEmail",
                sort: "asc",
                width: 150,
            },
            {
                label: "Course Title",
                field: "courseTitle",
                sort: "asc",
                width: 150,
            },
            {
                label: "Course Price",
                field: "coursePrice",
                sort: "asc",
                width: 100,
            },
        ],
        rows: referralHistory?.map((row, index) => ({
            serialNo: index + 1, // Add 1 to start counting from 1
            studentEmail: row.studentEmail, // Render student email
            courseTitle: row.course?.title, // Render course title
            coursePrice: row.course?.price, // Render course price
            // clickEvent: () => handleRowClick(row)
        }))
    };

    const handleRowClick = (row) => {

        setModalShow(true);
        setId(row?.id);
        setSubCategoryName(row?.name);
        setSubCategoryDescription(row?.description);
        setCategory(row?.categoryDto)
    }

    const handleUpdate = async () => {
        try {
            if (!subCategoryDescription || !subCategoryName || !category) {
                setSpanDisplay("inline");
            }
            else {
                setLoader(true);
                const data = await updateSubCategory({ id, name: subCategoryName, description: subCategoryDescription, categoryDto: category });
                setLoader(false);
                if (data?.success) {
                    toast.success(data?.message);
                    setModalShow(false)
                    fetchSubCategories();
                }
                else {
                    toast.error(data?.message);
                }
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }


    const handleDelete = async () => {
        try {
            setLoader(true);
            const data = await deleteSubCategory(id);
            setLoader(false);
            if (data?.success) {
                toast.success(data?.message);
                setModalShow(false);
                setDeleteModalShow(false);
                fetchSubCategories();
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }


    const handleSelectCategory = selectedOption => {
        setCategory(selectedOption);
    };

    const handleSubmit = async (e) => {
        try {
            setLoader(true);
            const data = await getReferralByUser({ trainer, paymentStatus: referralStatus.name, fromDate, toDate });
            if (data?.success) {
                setReferralHistory(data?.result);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    return (
        <React.Fragment>

            {loader ? (
                <>
                    < Loader />
                </>
            ) : ("")}


            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            {/* <CardTitle className="h4">All Referrals </CardTitle> */}
                            <div className="row  mb-4">
                                <div className="col-md-3">
                                    <label htmlFor="trainer" className="form-label">Select Trainer</label>

                                    <Select

                                        value={trainer}
                                        onChange={(selectedOption) => setTrainer(selectedOption)}
                                        options={allTrainers}
                                        getOptionLabel={option => option.name}
                                        getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                        classNamePrefix="select2-selection"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label htmlFor="referralStatus" className="form-label">Select Status</label>

                                    <Select

                                        value={referralStatus}
                                        onChange={(selectedOption) => setReferralStatus(selectedOption)}
                                        options={referralStatusData}
                                        getOptionLabel={option => option.name}
                                        getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                        classNamePrefix="select2-selection"
                                    />
                                </div>

                                <div className="col-md-2">
                                    <label htmlFor="fromDate" className="form-label">From Date</label>
                                    <input
                                        type="date"
                                        id="fromDate"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                        className="form-control"
                                    />
                                </div>

                                <div className="col-md-2">
                                    <label htmlFor="toDate" className="form-label">To Date</label>
                                    <input
                                        type="date"
                                        id="toDate"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="fromDate" className="form-label"></label>

                                    <button
                                        type="button"
                                        onClick={handleSubmit}
                                        className="btn btn-primary mt-4"
                                    >
                                        Search
                                    </button>
                                </div>
                            </div>

                            <MDBDataTable
                                className="table-row-hover"
                                responsive
                                bordered
                                data={data}
                                style={{ cursor: 'pointer' }}
                                noBottomColumns
                                paging={{ page, onPageChange: setPage }}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Modal for  edit sub category  */}
            <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Sub Category
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>


                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Category
                        </label>
                        <div className="col-md-10">
                            <Select

                                value={category}
                                onChange={handleSelectCategory}
                                options={categories}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                classNamePrefix="select2-selection"
                            />
                            {!category && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Sub Category Name
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Class"
                                value={subCategoryName}
                                maxLength="50"
                                onChange={(e) => setSubCategoryName(e.target.value)} />
                            {!subCategoryName && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Sub Category Description
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter New Description"
                                value={subCategoryDescription}
                                maxLength="50"
                                onChange={(e) => setSubCategoryDescription(e.target.value)} />
                            {!subCategoryDescription && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setModalShow(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}
                    <Button type="button" color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false) }} className="waves-effect waves-light">Delete</Button>{" "}

                </Modal.Footer>
            </Modal>


            {/* Modal for delete confirmation  */}
            <Modal
                show={deleteModalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Sub Category.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteModalShow(false); setModalShow(true) }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDelete} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal>

        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(AllReferrals);